import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "divider";
var classes = {
    ROOT: '.tyl-divider'
};
export var DIVIDER_CONSTANTS = {
    elementName: elementName,
    classes: classes
};
